import { FileData } from '@applyboard/school-applications-types-lib'
import {
  RawApplicationPagePropsResponse,
  useGetApplicationPageProps,
} from './useGetApplicationPageProps'
import { get } from 'lodash'

type GetLanguageProficiencyTypesProps = {
  files?: FileData
}

export function useGetLanguageProficiencyTypes(props: GetLanguageProficiencyTypesProps) {
  const { applicationPageProps } = useGetApplicationPageProps()

  const uploadedFile = Object.entries(props.files || {})
    .map(([, fileInfo]) => fileInfo)
    .find(fileInfo => fileInfo?.activeRecord)

  const testTypeOptions: Record<string, string> = {}

  if (isEnabled(applicationPageProps, 'ielts') || uploadedFile?.type === 'LANGUAGE_TEST_IELTS') {
    testTypeOptions.IELTS = 'IELTS'
  }

  if (isEnabled(applicationPageProps, 'pte') || uploadedFile?.type === 'LANGUAGE_TEST_PTE') {
    testTypeOptions.PTE = 'PTE Academic'
  }

  if (isEnabled(applicationPageProps, 'toefl') || uploadedFile?.type === 'LANGUAGE_TEST_TOEFL') {
    testTypeOptions.TOEFL = 'TOEFL®️'
  }

  if (
    isEnabled(applicationPageProps, 'duolingo') ||
    uploadedFile?.type === 'LANGUAGE_TEST_DUOLINGO'
  ) {
    testTypeOptions.DUOLINGO = 'Duolingo'
  }

  if (isEnabled(applicationPageProps, 'cael') || uploadedFile?.type === 'LANGUAGE_TEST_CAEL') {
    testTypeOptions.CAEL = 'CAEL'
  }

  if (
    isEnabled(applicationPageProps, 'cambridge') ||
    uploadedFile?.type === 'LANGUAGE_TEST_CAMBRIDGE'
  ) {
    testTypeOptions.CAMBRIDGE = 'Cambridge'
  }

  if (isEnabled(applicationPageProps, 'met') || uploadedFile?.type === 'LANGUAGE_TEST_MET') {
    testTypeOptions.MET = 'MET'
  }

  if (isEnabled(applicationPageProps, 'epp') || uploadedFile?.type === 'LANGUAGE_TEST_EPP') {
    testTypeOptions.EPP = 'English Pathway Program'
  }

  if (isEnabled(applicationPageProps, 'other') || uploadedFile?.type === 'LANGUAGE_TEST_OTHER') {
    testTypeOptions.OTHER = 'Other'
  }

  return testTypeOptions
}

function isEnabled(props: RawApplicationPagePropsResponse['data'] | undefined, field: string) {
  return get(props, `specificFields.languageProficiency.proofTypes.${field}.enabled`)
}
